import React from 'react';

const BillStatsBar = ({ bills }) => {
    // Calculate stats
    const totalCount = bills.length;
    const totalAmount = bills.reduce((sum, b) => sum + (parseFloat(b.totalAmount) || 0), 0);
    const totalPending = bills.reduce((sum, b) => {
        const status = b.paymentDetails?.status || b.paymentStatus;
        if (status === 'Paid') return sum;

        // Calculate Balance
        // 1. Try explicit balance first (System)
        if (b.paymentDetails?.balance !== undefined && b.paymentDetails?.balance !== null) {
            return sum + parseFloat(b.paymentDetails.balance);
        }

        // 2. Fallback: Total - Paid (Legacy or System fallthrough)
        const total = parseFloat(b.totalAmount || b.amount || 0);
        const paid = parseFloat(b.paymentDetails?.advance || b.paidAmount || 0);
        return sum + Math.max(0, total - paid);
    }, 0);

    return (
        <div className="stats-bar">
            <div className="stat-card">
                <span className="stat-label">Total Bills</span>
                <span className="stat-value">{totalCount}</span>
            </div>
            <div className="stat-card" style={{ borderLeftColor: '#2e7d32' }}>
                <span className="stat-label">Total Revenue</span>
                <span className="stat-value">₹{totalAmount.toLocaleString()}</span>
            </div>
            <div className="stat-card" style={{ borderLeftColor: '#f57f17' }}>
                <span className="stat-label">Pending Amount <span style={{ fontSize: '10px', color: '#888', fontWeight: 'normal' }}>(Unpaid + Partial)</span></span>
                <span className="stat-value">₹{totalPending.toLocaleString()}</span>
            </div>
        </div>
    );
};

export default BillStatsBar;
